import React from 'react';
import { useNavigate } from 'react-router-dom';
import './main_dashboard.css';

function Dashboard() {
  const navigate = useNavigate();

  return (
    <div className="dashboard-cards">
      <div className="agent-card" onClick={() => {
        console.log("Navigating to /bank-agent");
        navigate('/bank-agent');
      }}>        <img src="images/bank_agent.avif" alt="Bank Agent" />
        <h4>Bank Agent</h4>
      </div>
      {/* <div className="agent-card" onClick={() => navigate('/quote-agent')}>
        <img src="images/quote.png" alt="Quote Agent" />
        <h4>Quote Agent</h4>
      </div> */}
    </div>
  );
}

export default Dashboard;
